/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetMobileAnnouncementDraftModel,
  IGetMobileAnnouncementDraftRequest,
  IMappers,
  IGetMobileAnnouncementDraftResponse,
  IGetMobileAnnouncementDraftResponseError,
  TGetMobileAnnouncementDraftResponse,
} from './types';

const defaultConfig: TGetMobileAnnouncementDraftModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'announcements',
  pathApi: '/v1/get-mobile-announcement-draft/',
  hostType: 'api',
  responseType: 'json',
} as TGetMobileAnnouncementDraftModel;

function createGetMobileAnnouncementDraftModel(
  parameters: IGetMobileAnnouncementDraftRequest,
): TGetMobileAnnouncementDraftModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetMobileAnnouncementDraftOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetMobileAnnouncementDraftRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetMobileAnnouncementDraft<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetMobileAnnouncementDraftOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetMobileAnnouncementDraftResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetMobileAnnouncementDraftModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetMobileAnnouncementDraftResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetMobileAnnouncementDraftResponseError);
    }
  }

  return { response, statusCode } as TGetMobileAnnouncementDraftResponse;
}

export { defaultConfig, createGetMobileAnnouncementDraftModel, fetchGetMobileAnnouncementDraft };
